<template>
    <v-toolbar class="background_bar" absolute height="64px" dark style="max-height:104px; z-index:99; position:fixed; width:100%">
            <v-col cols="9" class="pl-0">
                <router-link to="/home" class="justify-self-start;" style="display:contents">            
                    <div style="width:266px">
                        <v-img :src="require('../assets/temp-logo-with-title.png')" contain height="50px" width="223px" style=" margin-bottom:2px"/>
                    </div>
                </router-link>
            </v-col>
            <v-col cols="3" style="display:flex; justify-content:flex-end; align-self:center;">
                <div v-if="mobile">
                    <v-menu offset-y>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn v-on="on" v-bind="attrs"><v-icon>menu</v-icon></v-btn>
                        </template>
                        <v-list style="background-color:rgb(27,23,23);border-width:4px;border-color:rgb(70,56,49);border-style:solid">
                            <!-- <v-img :src="require('../assets/big_bar.png')"> -->
                            <v-list-item v-for="button in buttons" :key="button.text">
                                <fancy-button :text="button.text" :color="button.color" :link="button.link" :icon="button.icon"></fancy-button>
                            </v-list-item>
                            <!-- </v-img> -->
                        </v-list>
                    </v-menu>
                </div>
                <fancy-button v-if="!mobile" text="Legal" color="red" link="/legal" icon="Menu.png"/>
                <fancy-button v-if="!mobile" text="Support" color="yellow" link="/support" icon="greed.png"/>
                <fancy-button v-if="!mobile" text="Guides" color="aqua" link="/rules/introduction" icon="Quest.png"/>
                <fancy-button v-if="!mobile" text="Play" color="lawngreen" link="/play" icon="Fight.png"/>
            </v-col>            
        </v-toolbar>
</template>
<script>
import fancyButton from "./fancyButton"

import {
  //VBtn,  
    VToolbar,
    VImg,
    VCol,
    VIcon,
    VBtn,
    VMenu,
    VList,
    VListItem,
} from "vuetify/lib";

export default {
  name: "App",
  components: {    
    VToolbar,
    VImg,
    VCol,         
    fancyButton,
    VIcon,
    VBtn,
    VMenu,
    VList,
    VListItem
  },
  data () {
    return {     
        mobile:false,
        buttons:[
            {text:"Legal", color:"red", link:"/legal", icon:"Menu.png"},
            {text:"Support", color:"yellow", link:"/support", icon:"greed.png"},
            {text:"Guides", color:"aqua", link:"/rules/introduction", icon:"Quest.png"},
            {text:"Play", color:"lawngreen", link:"/play", icon:"Fight.png"},
        ]
      }
    },
    mounted(){
        if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
            this.mobile = true
        }
    }
}
</script>
<style>
.v-toolbar__content{
    padding-left: 0px;
    width:100%;
}
.button{
    margin:8px;
}
.btn_center{
    display:flex;
    justify-content: center;
    height:40px;
    align-items: center;
}
.background_bar{
    background: url('../assets/basic_bar_elonged.png');
    background-size: 105% 76px;
    background-repeat:no-repeat;
    background-position-y: center;
    background-position-x: center;
}
</style>
